(function () {
  function attachAwarenessBarListeners() {
    if (!window.$) return;
    const EXPIRES_IN_ONE_DAY = 1;
    const awarenessBar = window.$('.ti-awareness-bar');

    window.$('.awareness-bar-close').on('click', function () {
      awarenessBar.slideUp();
      // Server will look for this cookie; if set, it won't instantiate an awareness bar
      if (window.Cookies)
        window.Cookies.set('awareness-bar-closed', true, { expires: EXPIRES_IN_ONE_DAY });
    });
  }

  if (document.readyState !== 'loading') {
    attachAwarenessBarListeners();
  } else {
    document.addEventListener('DOMContentLoaded', attachAwarenessBarListeners);
  }
})();
